import { z } from 'zod';

export interface CommercialService {
  id: string;
  name: string;
  description?: string;
  commercialName?: string;
  externalId?: string;
  status?: string;
  createdAt: string;
  updatedAt: string;
}

export const createCommercialServiceSchema = z.object({
  name: z.string().min(1, 'El nombre es requerido'),
  externalId: z.string().min(1, 'El ID externo es requerido'),
  description: z.string().optional(),
  commercialName: z.string().optional(),
});

export type CreateCommercialServiceSchema = z.infer<
  typeof createCommercialServiceSchema
>;

export const defaultCommercialServiceValues: CreateCommercialServiceSchema = {
  name: '',
  externalId: '',
  description: '',
  commercialName: '',
};

export interface UpdateCommercialService {
  name: string;
  description?: string;
  commercialName?: string;
}

export const updateCommercialServiceSchema = z.object({
  name: z
    .string()
    .min(1, 'El nombre es requerido')
    .min(3, 'El nombre debe tener al menos 3 caracteres')
    .max(50, 'El nombre no puede exceder 50 caracteres'),
  description: z.string().optional(),
  commercialName: z.string().optional(),
});

export type UpdateCommercialServiceSchema = z.infer<
  typeof updateCommercialServiceSchema
>;
